<template>
  <div class="service">
    <div class="page_tit_box">
      <div class="center_content u-flex">
        <div>
          <img class="tit_img" src="../assets/images/index_icon1.png" alt="">
        </div>
        <div>首页>保函服务</div>
      </div>
    </div>

    <div class="cert_center">
        <div class="ser_line"></div>

        <div class="ser_tit">
          保函服务
        </div>

        <div class="form_box">
          <el-form
            class="ser_form"
            ref="serform"
            :inline="true"
            label-position="top"
            :hide-required-asterisk="true"
            :model="serForm"
            :rules="rules"
          >
            <el-form-item class="formItem" label="1、请选择保函类型" prop="bhType">
              <el-radio-group v-model="serForm.bhType" class="mycheck_box">
                <el-radio-button label="投标保函(线下)"></el-radio-button>
                <el-radio-button label="履约/预付款保函"></el-radio-button>
                <el-radio-button label="质量/农民工/支付保函"></el-radio-button>
              </el-radio-group>
            </el-form-item>

            <el-form-item class="formItem" label="2、请选择出函机构" prop="chJigou">
              <el-radio-group v-model="serForm.chJigou" class="mycheck_box">
                <el-radio-button label="银行"></el-radio-button>
                <el-radio-button label="担保公司"></el-radio-button>
                <el-radio-button label="保险公司"></el-radio-button>
              </el-radio-group>
            </el-form-item>

            <div class="form_b_tit">
              3、基本信息
            </div>
            <el-form-item class="s_form_t" label="甲方名称" prop="jfName">
              <el-input
                class="inlineInput"
                v-model="serForm.jfName"
                placeholder="请输入甲方名称"
              ></el-input>
            </el-form-item>

            <el-form-item class="s_form_t" label="乙方名称" prop="yfName">
              <el-input
                class="inlineInput"
                v-model="serForm.yfName"
                placeholder="请输入乙方名称"
              ></el-input>
            </el-form-item>

            <el-form-item class="s_form_t" label="甲方类型" prop="jfType">
              <el-select class="inlineInput" v-model="serForm.jfType" placeholder="请选择">
                <el-option label="国家机关" value="国家机关"></el-option>
                <el-option label="事业单位" value="事业单位"></el-option>
                <el-option label="央企国企" value="央企国企"></el-option>
                <el-option label="主板上市公司" value="主板上市公司"></el-option>
                <el-option label="国有参股" value="国有参股"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item class="s_form_t" label="乙方资质" prop="yfTzizhi">
              <el-select class="inlineInput" v-model="serForm.yfTzizhi" placeholder="请选择">
                <el-option label="特级" value="特级"></el-option>
                <el-option label="总包一级" value="总包一级"></el-option>
                <el-option label="总包二级" value="总包二级"></el-option>
                <el-option label="总包三级" value="总包三级"></el-option>
                <el-option label="专业一级" value="专业一级"></el-option>
                <el-option label="专业二级" value="专业二级"></el-option>
                <el-option label="专业三级" value="专业三级"></el-option>
                <el-option label="劳务不分等级" value="劳务不分等级"></el-option>
                <el-option label="甲级" value="甲级"></el-option>
                <el-option label="乙级" value="乙级"></el-option>
                <el-option label="生产型企业" value="生产型企业"></el-option>
                <el-option label="贸易/服务类企业" value="贸易/服务类企业"></el-option>
              </el-select>
            </el-form-item>

            <div class="form_b_tit">
              4、项目信息
            </div>
            <el-form-item class="s_form_t" label="项目名称" prop="projectName">
              <el-input
                class="inlineInput"
                v-model="serForm.projectName"
                placeholder="请输入项目名称"
              ></el-input>
            </el-form-item>

            <el-form-item class="s_form_t" label="保函金额" prop="bhMoney">
              <el-input
                class="inlineInput"
                type="number"
                v-model="serForm.bhMoney"
                placeholder="请输入金额"
              ></el-input>
            </el-form-item>

            <el-form-item class="s_form_t" label="项目类型" prop="projectType">
              <el-select class="inlineInput" v-model="serForm.projectType" placeholder="请选择">
                <el-option label="施工类" value="施工类"></el-option>
                <el-option label="采购/服务类" value="采购/服务类"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item class="s_form_t" label="保函期限" prop="bhEndDate">
              <el-date-picker
                class="inlineInput"
                v-model="serForm.bhEndDate"
                type="date"
                :clearable="false"
                placeholder="请输入期限">
              </el-date-picker>
            </el-form-item>

            <div class="form_b_tit">
              5、格式要求
            </div>

            <div class="myRadio_box">
              <el-radio v-model="serForm.geshi" label="1">有</el-radio>
              <el-radio v-model="serForm.geshi" label="2">无</el-radio>
            </div>

            <div class="form_b_tit_t">
              <span style="color:#D52C00">*</span>请留下您的联系方式，我们将尽快与您取得联系
            </div>
            <el-form-item class="s_form_t formItem" label="联系人" prop="llName">
              <el-input
                class="inlineInput"
                v-model="serForm.llName"
                placeholder="请输入您的姓名"
              ></el-input>
            </el-form-item>

            <el-form-item class="s_form_t formItem" label="联系电话" prop="llPhone">
              <el-input
                class="inlineInput"
                v-model="serForm.llPhone"
                placeholder="请输入您的手机号码"
              ></el-input>
            </el-form-item>

          </el-form>
        </div>

       <div class="certbtn_box">
        <el-button class="certbtn" type="primary"  @click="submitForm('serform')">提交</el-button>
      </div>

    </div>
  </div>
</template>

<script>
import { sesStorage } from "@/model/storage.js";
import Qs from "qs";
export default {
  name: "",
  components: {},
  data() {
    var phonerule = (rule, value, callback) => {
      const reg = 11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/;
      if (value === "") {
        callback(new Error("请输入您的手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入您的手机号码"));
      } else {
        callback();
      }
    };
    return {
      serForm:{
        llName:'',
        llPhone:'',
        bhType:'',
        chJigou:'',
        jfName:'',
        jfType:'',
        yfName:'',
        yfTzizhi:'',
        projectName:'',
        projectType:'',
        bhMoney:'',
        bhEndDate:'',
        geshi:'2',
      },
      rules: {
          llName: [
            { required: true, message: '请输入您的姓名', trigger: 'blur' },
          ],
          llPhone: [
            { required: true, validator: phonerule, trigger: "blur" },
          ],
        }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
                this.$http
                  .post("/front/apply/getApply", Qs.stringify(this.serForm))
                  .then((res) => {
                    if (res.data.code == 0) {
                      this.$message({
                        message: res.data.msg,
                        type: "success",
                        center: true,
                      });
                      this.serForm={}
                    } else {
                      this.$message({
                        message: res.data.msg,
                        type: "error",
                        center: true,
                      });
                    }
                  })
                  .catch((error) => {});
        } else {
          return false;
        }
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.service {
  .page_tit_box {
    background: #e2e4ee;
    padding: 20px 0;
    font-size: 14px;
  }
  .center_content {
    width: 1500px;
    margin: 0 auto;
    .tit_img{
      width: 14px;
      height: 18px;
      margin-right: 16px;
    }
  }
  .cert_center {
    position: relative;
    width: 1200px;
    background-color: #fff;
    margin: 20px auto;
  }

  .certbtn_box {
    width: 340px;
    margin: 38px auto 0 auto;
  }
  .certbtn {
    height: 42px;
    background: #303643;
    border-radius: 2px;
    color: #fff;
    border: none;
    width: 100%;
    margin-top: 30px;
    margin-bottom: 50px;
  }
  .ser_tit{
    line-height: 95px;
    text-align: center;
    font-size: 24px;
    color: #303643;
    font-weight: bold;
    border-bottom: 1px solid #303643;
  }
  .inlineInput {
    margin-right: 38px;
    & >>> .el-input__inner{
      width: 400px;
      background: #F9FAFE;
      border: 1px solid #303643;
      border-radius: 2px;
    }
    & >>> .el-select__caret {
      color: #303643;
    }
  }
  .form_b_tit{
     font-size: 16px;
      font-weight: bold;
      color: #303643;
      margin-top: 32px;
      margin-bottom: 24px;
  }
  .form_b_tit_t{
    font-size: 16px;
      font-weight: bold;
      color: #303643;
      margin-top: 80px;
      margin-bottom: 24px;
  }
  .ser_form {
    margin-top: 30px;
    & >>> .el-form-item__label{
      font-size: 16px;
      font-weight: bold;
      color: #303643;
    }
    & >>> .el-input__inner::placeholder{
      color: #999;
    }
  }
  .form_box{
    padding: 0 0 0 160px;
  }

  .mycheck_box{
    & >>> .el-radio-button{
      margin-right: 30px;
    }
   
    & >>> .el-radio-button__inner{
      border: none;
      border-radius: 2px;
      background-color: #E8ECF8;
    }
    & >>> .el-radio-button__orig-radio:checked + .el-radio-button__inner{
      background-color: #303643;
    }
  }
  .formItem{
    display: block;
  }

  .s_form_t{
    & >>> .el-form-item__label{
      font-size: 14px;
    }
  }
  
  .myRadio_box{
    &>>>.el-radio__label{
      color: inherit;
    }
    &>>>.el-radio__input.is-checked .el-radio__inner{
      border-color: #FF8D24;
      background: #FF8D24;
    }
  }
  .ser_line{
    width: 100%;
    height: 1px;
    border-top: 1px dashed #303643;
    position: absolute;
    bottom: 450px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/service.vue